import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ComingSoonCardProps {
  categoryId?: string;
  featureId?: string;
  variant?: "feature" | "category";
}

export function ComingSoonCard({
  categoryId,
  featureId,
  variant = "feature",
}: ComingSoonCardProps) {
  const { t } = useTranslation();

  let label = "";
  if (featureId) {
    label = t(`credits.features.${featureId}`, { defaultValue: featureId });
  } else if (categoryId) {
    label = t(`credits.category.${categoryId}`, { defaultValue: categoryId });
  }

  return (
    <Card className="h-full border-dashed bg-sky-50/40 dark:bg-sky-900/10">
      <CardContent
        className={cn(
          "flex flex-col items-start gap-2 pt-6",
          variant === "category" && "min-h-[120px] justify-center"
        )}
      >
        <Badge variant="outline" className="border-sky-300 text-sky-700">
          {t("credits.comingSoon")}
        </Badge>
        {label && (
          <h3
            className={cn(
              variant === "category"
                ? "text-lg font-semibold"
                : "text-sm font-medium"
            )}
          >
            {label}
          </h3>
        )}
        <p className="text-xs text-muted-foreground">
          {t("credits.comingSoonHint")}
        </p>
      </CardContent>
    </Card>
  );
}
